
document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.product_slide', {
    slidesPerView: 'auto', // Enable auto width adjustment
    spaceBetween: 10, // Space between slides
    loop: false, // Enable looping
    navigation: {
      nextEl: '.swiper-button-next', // Next button
      prevEl: '.swiper-button-prev', // Previous button
    },
  });

});

document.addEventListener("DOMContentLoaded", function () {
    const filters = document.querySelectorAll(".filter_menu .js-filter");

    filters.forEach((filter) => {
        filter.addEventListener("toggle", function () {
            if (this.open) {
                filters.forEach((otherFilter) => {
                    if (otherFilter !== this) {
                        otherFilter.open = false;
                    }
                });
            }
        });
    });
});


// document.addEventListener("DOMContentLoaded", function () {
//   // Get the dropdown element
//   const dropdown = document.querySelector(".product-form__input--dropdown select");

//   // Function to update the selected value display
//   const updateSelectedValue = () => {
//     const selectedOption = dropdown.options[dropdown.selectedIndex].value;
//     document.querySelector(".product-form__input--dropdown .selected-value").innerHTML = selectedOption;
//   };

//   // Add event listener to the dropdown
//   dropdown.addEventListener("change", updateSelectedValue);

//   // Initialize with the default selected value
//   updateSelectedValue();
// });

// $(document).ready(function() {
//   $('.product-form__controls-group .gold--image ').on('click', function() {
//     var selectedValue = $(this).attr('data-color');  
//     $('.product-form__group-name').find('.selected-value').text(selectedValue);  
//   });
// });

// $(document).on("click", ".list-menu > li:nth-child(2) ul.header__submenu li a", function(event) {
//   var link = $(this).attr("href");
//   if (link && link.indexOf("#") !== -1) {
//     console.log("Has a # in link", link);
//     window.location.href = link;
//     location.reload(true);
//   }
// });


document.addEventListener("click", function (event) {
  var target = event.target.closest(
    ".list-menu > li:nth-child(2) ul.header__submenu li a"
  );
  if (target) {
    var link = target.getAttribute("href");
    if (link && link.indexOf("#") !== -1) {
      console.log("Has a # in link", link);
      window.location.href = link;
      location.reload(true);
    }
  }
});

$('.facets-sorting__field .select__select').click(function(){
  $(this).parents('#FacetsWrapperDesktop').find('.disclosure-has-popup').removeAttr('open');
});
